import {ArrowTopRightOnSquareIcon} from "@heroicons/react/16/solid";
import {PhotoIcon} from "@heroicons/react/24/outline";
import {Ride} from "pages/Front/Booking/Credits/CreditCalculator/types";
import {CREDITS_CLASSES, RIDES} from "pages/Front/Booking/Credits/CreditCalculator/constants";
import React from "react";

interface RideCardProps {
    ride: Ride;
}

function RideCardContent({ride}: RideCardProps) {
    return (
        <>
            <div className="flex h-24 items-center justify-center overflow-hidden bg-panel lg:h-40">
                {ride.imageSrc ? (
                    <img
                        src={ride.imageSrc}
                        alt={ride.imageAlt ?? ride.name}
                        className="h-full w-full object-cover transition duration-300 group-hover:scale-[1.03]"
                    />
                ) : (
                    <span className="flex flex-col items-center gap-1 text-ink-muted">
                        <PhotoIcon className="h-6 w-6" aria-hidden="true" />
                        <span className="text-[10px]">Foto: {ride.name}</span>
                    </span>
                )}
            </div>
            <div className="flex items-baseline gap-2 px-3 py-2.5">
                <div className="min-w-0 flex-1">
                    <p className="flex items-center gap-1 truncate text-sm font-semibold text-ink">
                        {ride.name}
                        {ride.infoUrl && (
                            <ArrowTopRightOnSquareIcon className="h-3.5 w-3.5 shrink-0 text-ink-muted transition group-hover:text-ink" aria-hidden="true" />
                        )}
                    </p>
                    <p className="truncate text-xs text-ink-muted">{ride.descriptor}</p>
                </div>
                <p className={`text-base font-bold ${CREDITS_CLASSES.text}`}>
                    {ride.credits}
                    <span className="sr-only"> Credits</span>
                </p>
            </div>
        </>
    );
}

function RideCard({ride}: RideCardProps) {
    const cardClasses = "block overflow-hidden rounded-lg border border-line bg-white transition";

    if (!ride.infoUrl) {
        return (
            <li className={cardClasses}>
                <RideCardContent ride={ride} />
            </li>
        );
    }

    return (
        <li className="list-none">
            <a
                href={ride.infoUrl}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={`${ride.name} — mehr erfahren (öffnet in neuem Tab)`}
                className={`group ${cardClasses} hover:border-ink-muted focus-visible:outline-none focus-visible:ring-2 ${CREDITS_CLASSES.ring}`}
            >
                <RideCardContent ride={ride} />
            </a>
        </li>
    );
}

export function RideCards() {
    return (
        <ul className="RideCards hidden sm:grid grid-cols-1 gap-2.5 sm:grid-cols-3">
            {RIDES.map(ride => (
                <RideCard key={ride.id} ride={ride} />
            ))}
        </ul>
    );
}
